import type { SubmitHandler } from 'react-hook-form';
import { usePostAgreementAdd, usePatchAgreementEdit } from '@repo/api/endpoints/agreement';
import { useProviderStore } from '@repo/store/provider';
import { getP24MarketingAgreements } from '@repo/store/helpers';
import { AgreementAddRequestBodySchema } from '@repo/api/endpoints/agreement';

import { useMainHubStoreState } from '@/store/main-hub.store';

import { P24MarketingAgreementsFormType } from '../form/p24-marketing-agreements-form.schema';
import { marketingAgreementsDataToSend } from '../form/marketing-agreements-data-to-send';

export function useP24MarketingAgreementsFormLiberis() {
  const { merchantResponseData } = useMainHubStoreState();
  const {
    state: { currentProvider },
  } = useProviderStore();
  const { mutate: postAgreementAdd } = usePostAgreementAdd();
  const { mutate: patchAgreementEdit } = usePatchAgreementEdit();

  const p24marketingAgreements = getP24MarketingAgreements(
    merchantResponseData?.data.agreements?.marketing,
  );

  const onSubmit: SubmitHandler<P24MarketingAgreementsFormType> = (data) => {
    if (!merchantResponseData || !currentProvider) return;

    const payload: AgreementAddRequestBodySchema = {
      requestId: merchantResponseData.requestId,
      apiProvider: currentProvider,
      agreements: {
        marketing: marketingAgreementsDataToSend(data, merchantResponseData),
      },
    };

    if (p24marketingAgreements && p24marketingAgreements.length > 0) {
      patchAgreementEdit(payload);
    } else {
      postAgreementAdd(payload);
    }
  };

  return onSubmit;
}
